export default "__VITE_ASSET__rX3aaVyh__"